import React from 'react';
import { Link } from 'react-router-dom';
import heroBg from '../assets/c3.png';
import contactImage from '../assets/contact.jpg';
import {  MdPhone, MdLocationOn } from 'react-icons/md';
import { FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';


const Contact = () => {
  const offices = [
    {
      name: "Corporate Office Delhi",
      company: "WVT Elevators Private Limited",
      address: "A-35, 4th Floor, Street No. 02, Madhu Vihar Rd, Madhu Vihar, I.P.Extension, Patparganj, New Delhi, Delhi, 110092",
      mobile: "9999762470,9811484679",
      landline: "01141253738",
      tollFree: "18008918455",
      website: "wvtelevators.com",
      email: "sales@wvtelevators.com",
    },
    {
      name: "Branch Office Zirakpur (Punjab)",
      company: "WVT Elevators Private Limited",
      address: "Office No. 77, 3rd Floor, City Court Commercial Complex, Zirakpur Shimla Highway, Dhakoli, Zirakpur, Punjab 140603",
      mobile: "9999762470",
      mobile2: "9811484679",
      tollFree: "18008918455",
      website: "wvtelevators.com",
      email: "sales@wvtelevators.com",
    },
    {
      name: "Branch Office Pathankot (Punjab)",
      company: "WVT Elevators Private Limited",
      address: "Bridge No. 05, National Highway 44, Sujanpur, Distt. Pathankot, Punjab – 145023",
      mobile: "9811484679",
      tollFree: "18008918455",
    },
    {
      name: "Branch Office Ambedkar Nagar (U.P.)",
      company: "WVT Elevators Private Limited",
      address: "Office No. 01, Jalapur Phulwariya Road Laudhana Sohgupur, Ambedkar Nagar – 224149",
      mobile: "9999762470",
      tollFree: "18008918455",
    },
  ];

  return (
    <div className="w-full">
      {/* Hero Section */}
      <div className="hero-fullwidth h-[400px] md:h-[300px] hero-bg-color flex items-center">
        <div className="relative z-10 max-w-6xl mx-auto px-6 w-full">
          <h1 className="text-white text-5xl md:text-6xl lg:text-7xl font-bold drop-shadow-lg">
            FEEL FREE TO CONTACT US
          </h1>
          <div className="text-white mt-4 text-lg md:text-xl">
            <Link to="/" className="underline hover:text-gray-200">Home</Link> / Contact
          </div>
        </div>
      </div>

      {/* Offices Section */}
      <div className="max-w-7xl mx-auto py-12 px-6 flex flex-col md:flex-row gap-10">
        {/* Contact Info */}
        <div className="flex-1 space-y-6">
          {offices.map((office, idx) => (
            <div key={idx} className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition">
              <h2 className="text-2xl font-bold text-blue-600 mb-2">{office.name}</h2>
              {office.company && <h5 className="text-lg font-semibold mb-2">{office.company}</h5>}
              <p className="flex items-start text-gray-700 mb-2">
                <MdLocationOn className="mr-2 mt-1 text-blue-500" /> {office.address}
              </p>
              <div className="space-y-2 text-gray-700 mb-3">
                <p className="flex items-center">
                  <MdPhone className="mr-2 text-blue-500" /> Mobile: {office.mobile}
                </p>
                {office.landline && (
                  <p className="flex items-center">
                    <MdPhone className="mr-2 text-blue-500" /> Landline: {office.landline}
                  </p>
                )}
                {office.tollFree && (
                  <p className="flex items-center">
                    <MdPhone className="mr-2 text-blue-500" /> Toll-Free: {office.tollFree}
                  </p>
                )}
              </div>
              {office.email && (
                <p className="text-gray-700 mb-3">
                  <span className="font-semibold">Email: </span>
                  <a href={`mailto:${office.email}`} className="text-blue-600 hover:underline">
                    {office.email}
                  </a>
                </p>
              )}
              {office.website && (
                <p className="text-gray-700 mb-3">
                  <span className="font-semibold">Website: </span>
                  <a href={`https://${office.website}`} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">
                    {office.website}
                  </a>
                </p>
              )}
              <div className="flex flex-wrap gap-3">
                <a
                  href={`tel:${office.mobile}`}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg shadow-sm hover:bg-green-700 transition"
                >
                  <FaPhoneAlt /> Call
                </a>
                <a
                  href={`https://api.whatsapp.com/send?phone=91${office.mobile}&text=Hello%20WVT%20Elevators`}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-[#25D366] text-white rounded-lg shadow-sm hover:bg-[#1ebe5a] transition"
                >
                  <FaWhatsapp /> WhatsApp
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Contact Image */}
        <div className="flex-1 flex flex-col items-center md:items-end gap-6">
          <img
            src={contactImage}
            alt="Contact"
            className="w-full max-w-md rounded-xl shadow-lg object-cover"
          />
          <div className="flex flex-col w-full max-w-md gap-4 px-4 py-5 rounded-xl bg-white shadow-lg">
            <p className="text-gray-700 text-lg font-semibold">Call or WhatsApp us</p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="tel:9999762470"
                className="flex-1 inline-flex items-center justify-center gap-2 rounded-lg bg-green-600 text-white px-4 py-3 font-semibold shadow-md hover:bg-green-700 transition"
              >
                <FaPhoneAlt /> Call
              </a>
              <a
                href="https://api.whatsapp.com/send?phone=919999762470&text=Hello%20WVT%20Elevators"
                target="_blank"
                rel="noreferrer"
                className="flex-1 inline-flex items-center justify-center gap-2 rounded-lg bg-[#25D366] text-white px-4 py-3 font-semibold shadow-md hover:bg-[#1ebe5a] transition"
              >
                <FaWhatsapp /> WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Send Us a Message Section */}
      <div className="max-w-7xl mx-auto py-12 px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-600 mb-10">SEND US A MESSAGE</h2>

        <div className="flex flex-col md:flex-row gap-10">
          {/* Form */}
          <div className="flex-1 bg-white p-8 rounded-xl shadow-lg">
            <form className="space-y-6">
              <div>
                <label className="block mb-1 font-medium text-gray-700">Name</label>
                <input
                  type="text"
                  placeholder="Your Name"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
                />
              </div>
              <div>
                <label className="block mb-1 font-medium text-gray-700">Email</label>
                <input
                  type="email"
                  placeholder="Your Email"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
                />
              </div>
              <div>
                <label className="block mb-1 font-medium text-gray-700">Subject</label>
                <input
                  type="text"
                  placeholder="Subject"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
                />
              </div>
              <div>
                <label className="block mb-1 font-medium text-gray-700">Message</label>
                <textarea
                  rows={5}
                  placeholder="Write your message..."
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
                ></textarea>
              </div>
              <div className="flex justify-center">
                <button
                  type="submit"
                  className="px-8 py-3 rounded-lg bg-blue-600 text-white font-semibold shadow-md hover:bg-blue-700 transition"
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>

          {/* Map */}
          <div className="flex-1">
            <iframe
              title="WVT Elevators Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3606.652304760151!2d77.3052826!3d28.636317499999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d01592b6573f5%3A0xcd6bb3dbe467f17f!2sWVT%20Elevators%20Private%20Limited!5e1!3m2!1sen!2sin!4v1786005098736!5m2!1sen!2sin"
              width="100%"
              height="100%"
              className="rounded-xl shadow-lg min-h-[400px]"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
